import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

import { ReceivingReportService } from '@app/core/purchase-orders/services/receiving-report.service';

import { OrderApiService } from './../shared/services/api/order/order-api.service';
import { OrderSupplierReceivingReportsService } from './../shared/services/api/order/order-supplier-receiving-reports.service';
import { IReceivingReportState } from './interfaces/receiving-report.interface';
import { ReceivingReportStateService } from './receiving-report-state.service';

@Injectable({
  providedIn: 'root',
})
export class ReceivingFacadeService {
  constructor(
    private receivingReportStateService :ReceivingReportStateService,
    private orderSupplierReceivingReportsService :OrderSupplierReceivingReportsService,
    private receivingReportService :ReceivingReportService,
    private orderApiService :OrderApiService,
  ) {}

  getReceivingReportById(data :{
    id :number;
    params :{
      [param :string] :string | string[];
    };
  }) :Observable<any> {
    const { id, params } = data;
    this.receivingReportStateService.updateState({ loading: true });

    return this.orderSupplierReceivingReportsService.getById(id, params).pipe(
      finalize(() =>
        this.receivingReportStateService.updateState({ loading: false }),
      ),
      tap((response) => {
        this.receivingReportStateService.updateState({
          currentReceivingReport: response,
        });
      }),
    );
  }

  createReceivingReportShipment(payload :any) :Observable<any> {
    this.receivingReportStateService.updateState({ submitting: true });

    return this.orderSupplierReceivingReportsService.create(payload).pipe(
      finalize(() =>
        this.receivingReportStateService.updateState({ submitting: false }),
      ),
      tap((response) => {
        return response;
      }),
    );
  }

  updateReceiveReportShipment(id :number, payload :any) :Observable<any> {
    this.receivingReportStateService.updateState({ submitting: true });

    return this.orderSupplierReceivingReportsService.update(id, payload).pipe(
      finalize(() =>
        this.receivingReportStateService.updateState({ submitting: false }),
      ),
      tap((response) => {
        return response;
      }),
    );
  }

  onSearchReceivableOrders(params :{
    [param :string] :string | string[];
  }) :Observable<any> {
    this.receivingReportStateService.updateState({
      loadingReceivableOrders: true,
    });

    return this.orderApiService.searchReceivableOrders(params).pipe(
      finalize(() =>
        this.receivingReportStateService.updateState({
          loadingReceivableOrders: false,
        }),
      ),
      tap((receivablesOrder) => {
        this.receivingReportStateService.updateState({ receivablesOrder });
      }),
    );
  }

  onGetReceivableOrdersByType(params :{
    [param :string] :string | number | string[];
  }) :Observable<any> {
    this.receivingReportStateService.updateState({ loading: true });

    return this.orderApiService
      .getReceivablesByType(params)
      .pipe(
        finalize(() =>
          this.receivingReportStateService.updateState({ loading: false }),
        ),
      );
  }

  setState(newState :Partial<IReceivingReportState>) :void {
    this.receivingReportStateService.updateState({
      ...this.receivingReportStateService.state,
      ...newState,
    });
  }

  get loading$() :Observable<boolean> {
    return this.receivingReportStateService.loading$;
  }

  get submitting$() :Observable<boolean> {
    return this.receivingReportStateService.submitting$;
  }

  get currentReceivingReport$() :Observable<any> {
    return this.receivingReportStateService.currentReceivingReport$;
  }

  get receivablesOrder$() :Observable<any> {
    return this.receivingReportStateService.receivablesOrder$;
  }

  get loadingReceivableOrders$() :Observable<boolean> {
    return this.receivingReportStateService.loadingReceivableOrders$;
  }
}
